import { Button, Col, Form, Row } from 'antd';
import PageHeading from '../../../../../components/common/PageHeading';
import SubHeading from '../../../../../components/common/SubHeading'

import { Upload, message } from 'antd';
import RightBar from "../../../../../components/common/RightBar";
import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";

const { Dragger } = Upload;
const UploadBulkRighBar = [
    RightBarMethod("HELP TOPICS", "t1", <i className="fa-solid fa-circle-question"></i>, [
        RightBarMethod("How to Upload Bulk Bills", "1", "", "", ""),

    ]),]

const handleUpload = (info) => {
    if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
    }
};

const UploadBulkBill = () => {
    return (<>

        <PageHeading heading="Upload Bulk Bills" />

        <Form layout="vertical">

            <SubHeading subHeading="Instructions For Uploading" />
            <Row style={{
                display: 'flex', flexDirection:
                    'column'
            }}>
                <Col style={{ marginBottom: '1px' }}>
                    <p style={{ marginTop: '10px' }}>
                        Your template contains columns for your Bill Property Code (address), Payee Name, Amount, Bill Account (name or number), Bill Date, Due Date, and Posting Date which are required for upload.
                    </p>
                    <br></br>
                    <p>
                        Note: Rows with the same bill reference will be combined into a single bill with multiple line items.
                    </p>                                 <br></br>

                    <Button style={{
                        marginTop: '-5px', marginBottom: '10px'

                    }} >Download Template</Button>

                </Col>

                <Col >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '90px',
                            border: 'dashed 2px #ccc',
                            borderRadius: '5px',
                            padding: '10px',
                            margin: 'auto',
                        }}
                    >

                        <p style={{ margin: '0px 15px', fontWeight: 'bold' }}>
                            Drag File Here
                        </p>
                        <p style={{ margin: '0px 15px' }}>
                            or
                        </p>
                        <Dragger
                            name="file"
                            style={{ backgroundColor: 'transparent', border: 'none' }}
                            multiple={false}
                            beforeUpload={() => false}
                            onChange={handleUpload}
                        >
                            <Button >
                                Choose File to Add
                            </Button>
                        </Dragger>
                    </div>
                </Col>

                <Col style={{ marginTop: '10px' }}>
                    <div className="form-action page-actions-container">
                        <Button type="primary" >Submit</Button>
                        <Button >Cancel</Button>
                    </div>
                </Col>
            </Row>

        </Form>


        <div className="RightSidebar">
            <RightBar RightBarData={UploadBulkRighBar} />
        </div>
    </>
    )
}
export default UploadBulkBill;


